export default __webpack_public_path__ + "static/Sandra Williams-23d62be07a720b8c91b787dad206531b.jpg";